import { ActionTree } from 'vuex';
import { State } from './state';

export function createActions(): ActionTree<State, State> {
  return {};
}
